import {el, List, list, RedomComponent, setChildren} from "redom";
import { format } from "../commonHelpers";
import {disableWait, showWait} from "../globalHelpers";
import {LogHelpers} from "../logHelper";
import {S4yModal} from "../modals/s4yModal";
import {MediaOptions} from "./mediaOptions";
import {VideoListItem} from "./video-list-item/videoListItem";
import {VideoListItemOptions} from "./video-list-item/videoListItemOptions";

export class Media implements RedomComponent {
  logHelper: LogHelpers = new LogHelpers('Media');
  el: HTMLElement;
  videoListElement: List;
  loadMoreElement: HTMLButtonElement;
  videoPlayer: HTMLIFrameElement;

  videoList: any[] = [];
  first = 1;
  count = 0;
  num = 12;

  constructor(private options: MediaOptions) {
    // thumbnail list
    const videoListItemOptions: VideoListItemOptions = {
      likeUrl: options.likeUrl,
      postCommentUrl: this.options.postCommentUrl,
      commentImageIconUrl: this.options.commentImageIconUrl,
      likeImageIconUrl: this.options.likeImageIconUrl,
      commentListUrl: (mediaId: number) => format(this.options.commentListUrl, [mediaId]),
      postCommentButtonIconUrl: options.postCommentButtonIconUrl,
    };
    setChildren(this.options.containerElement, [
      this.videoListElement = list(el('div', {class: 'video-list s4y-masonry'}), VideoListItem, 'MEDIA_ID', videoListItemOptions),
      el('div', {class: 'video-list-paging'}, [
        this.loadMoreElement = el('button', {class: 'd-btn d-btn-primary video-list-load-more-btn'}, 'Load more')
      ]),
    ]);
    // thumbnail click event handler
    // create and open player modal
    this.videoListElement.el.addEventListener('thumbnailClicked', (evt: CustomEvent) => {
      this.logHelper.log('thumbnailClicked handler');
      evt.cancelBubble = true;
      const mediaId = evt.detail.MEDIA_ID;
      this.logHelper.log(`Open video, MEDIA_ID = ${mediaId}`);
      const video = this.videoList.find(v => v.MEDIA_ID === mediaId);
      if (video) {
        // player modal
        let playerModal = new S4yModal('video-player-modal', 'xl');
        playerModal.$modalClosed = () => {
          playerModal = undefined;
        };
        const modalBody = playerModal.getModalBody();
        let modalCloseBtnElement: HTMLButtonElement;
        setChildren(modalBody, [
          modalCloseBtnElement = el('button', {class: 'd-close close-out', type: 'button'}, [el('span', '×')]),
          el('div', {class: 'd-embed-responsive d-embed-responsive-16by9'}, [
            this.videoPlayer = el('iframe', {
              class: 'd-embed-responsive-item',
              allowscriptaccess: 'always',
              allow: 'autoplay',
              allowfullscreen: 'true'
            })
          ])
        ]);
        modalCloseBtnElement.addEventListener('click', () => {
          playerModal.closeModal();
        });
        playerModal.append(modalBody);
        this.logHelper.log(video);
        this.videoPlayer.src = `https://iframe.videodelivery.net/${video.MEDIA_UID}`;
        playerModal.openModal();
      }
    });

    // load more button event handler
    this.loadMoreElement.addEventListener('click', () => {
      this.loadVideoFromRemote(this.first + this.num, this.num);
    });

    // first load video list from remote api, will load the first page
    this.loadVideoFromRemote(this.first, this.num);
  }

  update?(item: any, index: number, data: any, context?: any): void {
  }

  onmount?(): void {
  }

  onremount?(): void {
  }

  onunmount?(): void {
  }


  loadVideoFromRemote(first: number, num: number) {
    showWait();
    fetch(`${this.options.mediaListUrl}&first=${first}&num=${num}`).then(rep => rep.ok ? rep.json() : {}).then((data: any) => {
      disableWait();
      if (Object.keys(data).length > 0) {
        this.first = data.paging.first;
        if (data.paging.count) {
          this.count = data.paging.count;
        }

        // disable load more button if need
        if (this.first + this.num - 1 >= this.count) {
          this.loadMoreElement.disabled = true;
        }

        this.videoList = [
          ...this.videoList,
          ...data.list
        ];
        this.logHelper.log('videoList');
        this.logHelper.log(this.videoList);
        this.videoListElement.update(this.videoList);
      }
    });
  }
}